import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, I } from '@leanin/ui';
import { useTranslations } from '@/i18n/translations';
import { FlowShell, type FlowStep } from '@/components/onboarding/FlowShell';
import { ChecklistColumn } from '@/components/onboarding/ChecklistColumn';
import { useFinishOnboarding } from '@/components/onboarding/finish-onboarding';
import { PERSONA_STEP_KEYS } from '@/components/onboarding/persona-steps';

const STEPS: ReadonlyArray<FlowStep> = [
  { label: 'Welcome' },
  { label: 'Find a Circle to join' },
  { label: 'Connect with your community' },
  { label: 'Build leadership skills' },
  { label: "You're in" },
];

export const Route = createFileRoute('/onboarding/cm/complete')({
  component: CMOnboardingCompletePage,
});

function CMOnboardingCompletePage() {
  const navigate = useNavigate();
  const finish = useFinishOnboarding('cm');
  const t = useTranslations('Onboarding');
  return (
    <FlowShell
      role="Circle Member"
      stepIndex={4}
      steps={STEPS}
      title="Let's get started."
      primary={
        <Button variant="primary" icon={I.arrow} onClick={() => void finish()}>
          Finish onboarding
        </Button>
      }
      secondary={
        <Button
          variant="ghost"
          onClick={() => navigate({ to: '/onboarding/cm/welcome' })}
        >
          Return to welcome message
        </Button>
      }
    >
      <ChecklistColumn
        title={t('checklist.title.circleMember')}
        steps={PERSONA_STEP_KEYS['circle-member']}
        onNavigate={(href) => void finish(href)}
      />
    </FlowShell>
  );
}
